<template lang="html">
	<div style="border: 1px solid #ccc;">
        <Toolbar
			class="toolbar"
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            style="height: 100%;"
            :value="value"
            :defaultConfig="editorConfig"
            :mode="mode"
			@input="handleInput"
            @onCreated="onCreated"
			@customPaste="customPaste"
        />
    </div>
	<!-- <div class="editor">
		<div ref="toolbar" class="toolbar">
		</div>
		<div ref="editor" class="text">
		</div>
	</div> -->
</template>


<style src="@wangeditor/editor/dist/css/style.css"></style>
<script>
import Vue from 'vue'
import config from '../config.js'
import {uploadImgByUrlApi,uploadImg} from '../api/content.js'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default Vue.extend({
    components: { Editor, Toolbar },
	name: 'editoritem',
	props: {
		value: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			// uploadPath,
			editor: null,
			info_: '',
			toolbarConfig: { },
			editorConfig: {
				MENU_CONF: {
				uploadImage: {
					server: config.baseURL + 'upload', // 配置服务器端地址
					// 超时时间，默认为 10 秒
					timeout: 3 * 60 * 1000, // 3min
					fieldName: "file",
					// 将 meta 拼接到 url 参数中，默认 false
					metaWithUrl: false, // join params to url
					// 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
					meta: { dataKey: 0, bizType: "common" },
					// 自定义增加 http  header
					// headers: {
					//   Accept: "text/x-json",
					//   otherKey: "xxx"
					// },
					// 跨域是否传递 cookie ，默认为 false
					// withCredentials: true,
					// 自定义增加 http  header
					// headers: {
					//   Accept: "text/x-json",
					//   otherKey: "xxx"
					// },
					maxFileSize: 2 * 1024 * 1024, // 10M
					// base64LimitSize: 5 * 1024, // insert base64 format, if file's size less than 5kb
					// 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
					allowedFileTypes: ["image/*"],
					// 最多可上传几个文件，默认为 100
					maxNumberOfFiles: 6,
					onBeforeUpload(file) {
						console.log("onBeforeUpload", file);
			
						return file; // will upload this file
						// return false // prevent upload
					},
					// 自定义插入图片
					customInsert: (result,insertImg) => {
						let baseUrlStr = config.baseURL.split('api/')[0]
						let url = baseUrlStr + "public/uploads/" + result.data.filename
						// let url = "http://localhost:3000/public/uploads/" + result.data.filename
						insertImg(url)
					},
					onProgress(progress) {
						console.log("onProgress", progress);
					},
					onSuccess(file, res) {
						console.log("onSuccess", file, res);
					},
					onFailed(file, res) {
						alert(res.message);
						console.log("onFailed", file, res);
					},
					onError(file, err, res) {
						alert(err.message);
						console.error("onError", file, err, res);
					}
				},
				uploadVideo: {
					server: config.baseURL + 'upload',
					fieldName: "file",
					// 单个文件的最大体积限制，默认为 10M
					maxFileSize: 5 * 1024 * 1024, // 5M
					// 最多可上传几个文件，默认为 5
					maxNumberOfFiles: 3,
					// 选择文件时的类型限制，默认为 ['video/*'] 。如不想限制，则设置为 []
					allowedFileTypes: ["video/*"],
					// 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
					meta: { dataKey: 0, bizType: "video" },
					// 将 meta 拼接到 url 参数中，默认 false
					metaWithUrl: false,
					// 自定义增加 http  header
					// headers: {
					//   Accept: "text/x-json",
					//   otherKey: "xxx"
					// },
					// 跨域是否传递 cookie ，默认为 false
					withCredentials: true,
					// 超时时间，默认为 30 秒
					timeout: 30 * 1000, // 15 秒
					// 自定义插入视频
					customInsert(res, insertFn) {
						let baseUrlStr = config.baseURL.split('api/')[0]
						// 因为自定义插入导致onSuccess与onFailed回调函数不起作用,自己手动处理
						let url = baseUrlStr + "public/uploads/" + res.data.filename
						insertFn(url)
					},
					// 上传进度的回调函数
					onProgress(progress) {
					console.log("progress", progress);
					},
					// 单个文件上传成功之后
					onSuccess(file, res) {
					console.log(`${file.name} 上传成功`, res);
					},
					// 单个文件上传失败
					onFailed(file, res) {
					console.log(`${file.name} 上传失败`, res);
					},
					// 上传错误，或者触发 timeout 超时
					onError(file, err, res) {
					console.log(`${file.name} 上传出错`, err, res);
					}
				}
			},
			},
            mode: 'default', // or 'simple'
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
    methods: {
        onCreated(editor) {
			this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
		},
		handleInput(value) {
			// 将文本内容传给父组件（引用这个组件的vue文件的）
			this.$emit('change', value) // 将内容同步到父组件中
		},
		//重点来了： 自定义粘贴。可阻止编辑器的默认粘贴，实现自己的粘贴逻辑。(可以实现复制粘贴 word ，有图片)
		async customPaste(editor, event, callback) {
			let html = event.clipboardData.getData("text/html"); // 获取粘贴的 html
			// let text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
			let rtf = event.clipboardData.getData("text/rtf"); // 获取 rtf 数据（如从 word wsp 复制粘贴）
			let that = this;
			if (html || rtf) {
				// 阻止默认的粘贴行为
				event.preventDefault();
				if(rtf){
					// 列表缩进会超出边框，直接过滤掉
					html = html.replace(/text-indent:(.*?)pt/gi, "");
					// html = html.replace(/text\-indent:\-(.*?)pt/gi, "");

					// 从html内容中查找粘贴内容中是否有图片元素，并返回img标签的属性src值的集合
					const imgSrcs = that.findAllImgSrcsFromHtml(html);


					// 如果有
					if (imgSrcs && Array.isArray(imgSrcs) && imgSrcs.length) {
						// 从rtf内容中查找图片数据
						// const rtfImageData = that.extractImageDataFromRtf(rtf);


						// 如果找到
						if (imgSrcs.length) {
							console.log(imgSrcs)
							// TODO：此处可以将图片上传到自己的服务器上
							const imgRes =  that.rtfUploadImg(imgSrcs)

							console.log(imgRes)
							// 执行替换：将html内容中的img标签的src替换成ref中的图片数据，如果上面上传了则为图片路径
							html = that.replaceImagesFileSourceWithInlineRepresentation(
								html,
								imgSrcs,
								imgRes
							);
							editor.dangerouslyInsertHtml(html);
						}
					}else{
						editor.dangerouslyInsertHtml(html);
					}

					// 阻止默认的粘贴行为
					event.preventDefault();
					// return false;
					callback(false)
				}else{
					// 列表缩进会超出边框，直接过滤掉
					// html = html.replace(/text-indent:(.*?)pt/gi, "");

					// 从html内容中查找粘贴内容中是否有图片元素，并返回img标签的属性src值的集合
					const imgSrcs = that.findAllImgSrcsFromHtml(html);

					// 如果有
					if (imgSrcs && Array.isArray(imgSrcs) && imgSrcs.length) {

							// TODO：此处可以将图片上传到自己的服务器上
							//调用axios上传
							let res = await uploadImgByUrlApi(imgSrcs)
							if(res.code == 2000){
								// 执行替换：将html内容中的img标签的src替换成ref中的图片数据，如果上面上传了则为图片路径
								html = that.replaceImagesFileSourceWithUploadHtml(
									html,
									imgSrcs,
									res.data.filenameArr
								);
							}
							editor.dangerouslyInsertHtml(html);
					}else{
						editor.dangerouslyInsertHtml(html);
					}
					// return false;
					callback(false)
				}
			} else {
				callback(true)
				// return true;
			}
		},
		rtfUploadImg(imgSrcs) {
			let imgRes = []
			const that = this
			imgSrcs.forEach(imgSrc => {
				// 提取源文件路径
				// let src = imgSrc.match(/src="([^"]*)"/)[1]
				if ((/^file:\/\/\//).test(imgSrc)) {
					// 移除 URL 开头的 'file:///' 才能得到文件的本地路径
					let path = imgSrc.replace(/^file:\/\/\//, '')
					fetch(path) //浏览器不允许
					.then(res => res.blob())
					.then(blob => {
						// 使用在上面的例子中定义的 uploadImage() 函数上传图片
						console.log(blob)
						let imageUrl = that.uploadImage(blob)  // 假设 uploadImage 会返回新的图片Url
						console.log(imageUrl)
						if (imageUrl) {
							imgRes.push(imageUrl)
						}
					})
					.catch(err => console.error(err))
				}
			})
			return imgRes
		},
		async uploadImage(data) {
			let file = new File([data],'blob.png')
			let formData = new FormData()
			formData.append('file', file)
			//调用axios上传
			let res = await uploadImg(formData)
			return 'public/uploads/' + res.data.filename
		},
		/**
		 * 从html代码中匹配返回图片标签img的属性src的值的集合
		 * @param htmlData
		 * @return Array
		 */
		findAllImgSrcsFromHtml(htmlData) {
			let imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
			let srcReg = /src=['"]?([^'"]*)['"]?/i; // 匹配图片中的src
			// let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src

			let arr = htmlData.match(imgReg); //筛选出所有的img
			if (!arr || (Array.isArray(arr) && !arr.length)) {
				return false;
			}
			console.log(arr)

			let srcArr = [];
			for (let i = 0; i < arr.length; i++) {
				let src = arr[i].match(srcReg);
				// 获取图片地址
				srcArr.push(src[1]);
			}
			return srcArr;
		},
		/**
		 * 从rtf内容中匹配返回图片数据的集合
		 * @param rtfData
		 * @return Array
		 */
		extractImageDataFromRtf(rtfData) {
			if (!rtfData) {
				return [];
			}

			// const regexPictureHeader =
			// 	/{\\pict[\s\S]+?({\\\*\\blipuid\s?[\da-fA-F]+)[\s}]*/;
			// const regexPicture = new RegExp(
			// 	"(?:(" + regexPictureHeader.source + "))([\\da-fA-F\\s]+)\\}",
			// 	"g"
			// );
			const regexPictureHeader = /{\\pict[\s\S]+?({\\\*\\blipuid\s?[\da-fA-F]+)[\s}]*/;
			const regexPicture = new RegExp("(?:(" + regexPictureHeader.source + "))([\\da-fA-F\\s]+)\\}", "g");
			const images = rtfData.match(regexPicture);
			const result = [];

			if (images) {
				for (const image of images) {
				let imageType = false;

				if (image.includes("\\pngblip")) {
					imageType = "image/png";
				} else if (image.includes("\\jpegblip")) {
					imageType = "image/jpeg";
				}

				if (imageType) {
					result.push({
					hex: image
						.replace(regexPictureHeader, "")
						.replace(/[^\da-fA-F]/g, ""),
					type: imageType,
					});
				}
				}
			}

			return result;
		},
		/**
		 * 将html内容中img标签的属性值替换
		 * @param htmlData html内容
		 * @param imageSrcs html中img的属性src的值的集合
		 * @param imagesHexSources rtf中图片数据的集合，与html内容中的img标签对应
		 * @param isBase64Data 是否是Base64的图片数据
		 * @return String
		 */
		replaceImagesFileSourceWithInlineRepresentation(
		htmlData,
		imageSrcs,
		imagesHexSources,
		isBase64Data = true
		) {
			if (imageSrcs.length === imagesHexSources.length) {
				for (let i = 0; i < imageSrcs.length; i++) {
				const newSrc = isBase64Data
					? `data:${
						imagesHexSources[i].type
					};base64,${this._convertHexToBase64(imagesHexSources[i].hex)}`
					: imagesHexSources[i];

				htmlData = htmlData.replace(imageSrcs[i], newSrc);
				}
			}

			return htmlData;
		},
		/**
		 * 将html内容中img标签的属性值替换
		 * @param htmlData html内容
		 * @param imageSrcs html中img的属性src的值的集合
		 * @param imagesHexSources rtf中图片数据的集合，与html内容中的img标签对应
		 * @param isBase64Data 是否是Base64的图片数据
		 * @return String
		 */
		replaceImagesFileSourceWithUploadHtml(
		htmlData,
		imageSrcs,
		imagesSources
		) {
			console.log(imageSrcs)
			console.log(imagesSources)
			if (imageSrcs.length === imagesSources.length) {
				for (let i = 0; i < imageSrcs.length; i++) {
					htmlData = htmlData.replace(imageSrcs[i], config.baseURL + imagesSources[i]);
				}
			}
			console.log('444')
			console.log(htmlData)
			return htmlData;
		},
		/**
		 * 十六进制转base64
		 */
		_convertHexToBase64(hexString) {
		return btoa(
				hexString
				.match(/\w{2}/g)
				.map((char) => {
					return String.fromCharCode(parseInt(char, 16));
				})
				.join("")
			);
		},
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
})
</script>


<style>
.toolbar {
	border: 1px solid #ccc;
	position: sticky;
	top: -21px;
	z-index: 1000000000000000000;
}
.w-e-modal {
	transform: translateX(100%);
}
.w-e-text-container {
	min-height: 20rem;
}
</style>

<!-- <script>
	import E from 'wangeditor'
	import config from '../config.js'
	export default {
		name: 'editoritem',
		data() {
			return {
				// uploadPath,
				editor: null,
				info_: null
			}
		},
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
				type: String,
				default: ''
			},
			isClear: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			isClear(val) {
				// 触发清除文本域内容
				if (val) {
					this.editor.txt.clear()
					this.info_ = null
				}
			},
			value: function(value) {
				if (value !== this.editor.txt.html()) {
					this.editor.txt.html(this.value)
				}
			}
			//value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
		},
		mounted() {
			this.seteditor()
			this.editor.txt.html(this.value)
		},
		methods: {
			seteditor() {
				// http://192.168.2.125:8080/admin/storage/create
				this.editor = new E(this.$refs.toolbar, this.$refs.editor)
				this.editor.config.uploadImgShowBase64 = false // base 64 存储图片
				this.editor.config.uploadImgServer = config.baseURL + 'upload' // 配置服务器端地址
				// this.editor.config.uploadImgServer = 'http://localhost:3000/upload' // 配置服务器端地址
				this.editor.config.uploadImgHeaders = {} // 自定义 header
				this.editor.config.uploadFileName = 'file' // 后端接受上传文件的参数名
				this.editor.config.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
				this.editor.config.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
				this.editor.config.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间

				// 配置菜单
				this.editor.config.menus = [
					'head', // 标题
					'bold', // 粗体
					'fontSize', // 字号
					'fontName', // 字体
					'lineHeight',//行高
					'italic', // 斜体
					'underline', // 下划线
					'strikeThrough', // 删除线
					'foreColor', // 文字颜色
					'backColor', // 背景颜色
					'link', // 插入链接
					'list', // 列表
					'justify', // 对齐方式
					'quote', // 引用
					'emoticon', // 表情
					'image', // 插入图片
					'table', // 表格
					'video', // 插入视频
					'code', // 插入代码
					'undo', // 撤销
					'redo', // 重复
					'fullscreen' // 全屏
				]

				this.editor.config.uploadImgHooks = {
					fail: (xhr, editor, result) => {
						// 插入图片失败回调
						console.log(xhr)
						console.log(editor)
						console.log(result)
					},
					success: (xhr, editor, result) => {
						// 图片上传成功回调
						console.log(xhr)
						console.log(editor)
						console.log(result)
					},
					timeout: (xhr, editor) => {
						// 网络超时的回调
						console.log(xhr)
						console.log(editor)
					},
					error: (xhr, editor) => {
						// 图片上传错误的回调
						console.log(xhr)
						console.log(editor)
					},
					customInsert: (insertImg, result) => {
						let url = config.baseURL + "public/uploads/" + result.data.filename
						// let url = "http://localhost:3000/public/uploads/" + result.data.filename
						insertImg(url)
					}
				}
				console.log(this.editor)
				this.editor.config.onchange = (html) => {
					this.info_ = html // 绑定当前逐渐地值
					this.$emit('change', this.info_) // 将内容同步到父组件中
				}
				// 创建富文本编辑器
				this.editor.create()
			}
		}
	}
</script> -->

<!-- <style lang="css">
	.editor {
		width: 100%;
		margin: 0 auto;
		position: relative;
		z-index: 0;
		margin-top: 20px;
	}

	.toolbar {
		border: 1px solid #ccc;
		position: sticky;
		top: -21px;
		z-index: 1000000000000000000;
	}

	.text {
		border: 1px solid #ccc;
		min-height: 500px;
	}
</style> -->
